import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW0907Component } from './kymw0907.component';
import { GetNvalDetailIdService } from './api-services/get-nval-detail-id.service';

/**
 * プロモ設定画面 1物N価モジュール設定クラス
 *
 * @export KYMW0907Module
 * @class KYMW0907Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppCommonsModule,
    PlessSharedModule,
    WjNavModule,
    WjGridModule,
    WjInputModule,
  ],
  declarations: [
    KYMW0907Component,
  ],
  providers: [
    GetNvalDetailIdService,
  ],
})
export class KYMW0907Module { }
